import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { format, isBefore, subHours } from "date-fns";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import LiveBaseImage from "@/components/live_video/LiveBaseImage.vue";
import LiveBaseVideo from "@/components/live_video/LiveBaseVideo.vue";
import LiveConnectionLost from "@/components/live_video/LiveConnectionLost.vue";
import { useLiveImageSetting, useStreams } from "@/composables/stream";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveBase',
  props: {
  cameraId: {
    type: String,
    required: true,
  },
  addRightSpaceToControlBar: {
    type: Boolean,
    required: false,
  },
},
  emits: ["videoHasError"],
  setup(__props, { emit: __emit }) {

const { useLiveImage } = useLiveImageSetting();
const camera = computed(() => props.cameraId);

const { streams } = useStreams();
const stream = computed(() => {
  return streams.value ? streams.value.find(({ camera_id }) => camera_id === camera.value) : null;
});

const props = __props;

const videoError = ref(false);

const { t } = useI18n();
const emits = __emit;

watch(videoError, () => {
  if (videoError.value) {
    emits("videoHasError");
  }
});

const routerConnectionLostMessage = computed(() => {
  if (
    stream.value &&
    stream.value.status === "offline" &&
    stream.value.status_updated_at &&
    isBefore(stream.value.status_updated_at, subHours(new Date(), 1))
  ) {
    if (videoError.value) {
      emits("videoHasError");
    }
    return `${t("dashboard.project.stream_card.connection_lost", {
      updatedAt: format(stream.value.status_updated_at, "dd.MM.yyyy HH:mm"),
    })}`;
  }
  return null;
});

return (_ctx: any,_cache: any) => {
  return (!_unref(useLiveImage) && !videoError.value)
    ? (_openBlock(), _createBlock(LiveBaseVideo, {
        key: 0,
        cameraId: props.cameraId,
        addRightSpaceToControlBar: __props.addRightSpaceToControlBar,
        noSrcMessage: routerConnectionLostMessage.value,
        onVideoUrlError: _cache[0] || (_cache[0] = ($event: any) => (videoError.value = true))
      }, null, 8, ["cameraId", "addRightSpaceToControlBar", "noSrcMessage"]))
    : (_unref(useLiveImage) && !videoError.value)
      ? (_openBlock(), _createBlock(LiveBaseImage, {
          key: 1,
          cameraId: props.cameraId,
          noSrcMessage: routerConnectionLostMessage.value,
          addRightSpaceToControlBar: __props.addRightSpaceToControlBar,
          onLowBandWidthError: _cache[1] || (_cache[1] = ($event: any) => (videoError.value = true))
        }, null, 8, ["cameraId", "noSrcMessage", "addRightSpaceToControlBar"]))
      : (_openBlock(), _createBlock(LiveConnectionLost, {
          key: 2,
          cameraId: camera.value,
          noSrcMessage: routerConnectionLostMessage.value
        }, null, 8, ["cameraId", "noSrcMessage"]))
}
}

})